/* global userInfoUrl, service, subagentUserRegisterUrl, userRegisterUrl */

var fadeInAndOutTime = 350;

function showUserInfo(response) {
    if (typeof step !== 'undefined' && step) {
        changeStep(3);
    }

    $('#reservationUserInfo').html(response.data.userInfo).show();
    $('#reservationUserType, #reservationLogin, #reservationRegister').hide();
    $('#userNotAuthenticated').hide();

    if (window['service'] == undefined || service == "private") {
        if ($('#reservationUserInfo').length < 1) {
            $('#reservationUser').prepend($('<div id="reservationUserInfo">'));
        }


        refreshSignOnSignOff(response);
        refreshCalculation();
    } else if(service == "lighthouse") {
        preCheck();

        $('#userNotAuthenticated').show();
        $('#reservationRegister').show();

        refreshSignOnSignOff(response);
        $('#reservationUserInfo').hide();

        if (response.data.r_user !== undefined) {
            removeRegistrationErrors();
            fillRegisteredUserData(response.data.r_user, '#ReservationLighthouseSingleForm_user_register_');
        }
    } else if (service == "charter") {
        preCheck();

        $('#userNotAuthenticated').show();
        $('#reservationRegister').show();

        refreshSignOnSignOff(response);
        $('#reservationUserInfo').hide();

        if (response.data.r_user !== undefined) {
            removeRegistrationErrors();
            fillRegisteredUserData(response.data.r_user, '#ReservationCharterSingleForm_user_register_');
        }
    }
}

function refreshLogin() {
    $('#userInlineResLoader').fadeIn(fadeInAndOutTime);
    $('#reservationUserWrap').find('input').blur();

    const loginData = {
        'username' : $('input[id$=_user_login_username]').val(),
        'password' : $('input[id$=_user_login_password]').val()
    };

    $.post(userInfoUrl, loginData, function(response){
        if (response.status == 'success') {
            showUserInfo(response);

            if (response.data.hasUserConsent) {
                $("#consent").hide();
            } else {
                if ($("#consent").is(":hidden")) {
                    $("#consent").show();
                }
            }
            if (response.data.isUserSubscribedToNewsletter) {
                $("#newsletter").hide();
            } else {
                if ($("#newsletter").is(":hidden")) {
                    $("#newsletter").show();
                }
            }

        } else {
            $('#reservationUserInfo').html('').hide();
            $('#reservationUserType, #reservationLogin').show();
            $('#reservationRegister').hide();

            var errorList = $('#reservationLogin ul.validationMessage');

            if (errorList.length) {
                errorList.html('');
            } else {
                $('#reservationLogin').prepend($('<ul class="validationMessage" />'));
            }

            $.each(response.data, function(field, error){
                $('#reservationLogin ul.validationMessage').append('<li>'+error+'</li>');
            });

            $('#userNotAuthenticated').show();
        }

        $('#userInlineResLoader').fadeOut(fadeInAndOutTime);
    });
}

function registerUser(subagent) {
    $('#userInlineResLoader').show();
    $('#reservationUserWrap').find('input').blur();

    var postData = {};
    var formName = subagent ? 'user_subagent_register' : 'user_register';

    $('[name*="['+formName+']"]').each(function(){
        var name = '[' + $(this).attr('name').replace(/^[a-zA-Z]+\[/, '');
        name = name.replace('['+formName+'][', '').replace(/]/gi, '');

        if (name.indexOf('phone') === 0 && !subagent) {
            if (postData.phone === undefined) {
                postData['phone'] = {};
            }

            postData['phone'][name.replace('phone[', '')] = $(this).val();
        } else {
            postData[name] = $(this).val();
        }
    });

    var registerAction = subagent ? subagentUserRegisterUrl : userRegisterUrl;

    $.ajax({
        type: "POST",
        url: registerAction,
        data: {'registration' : postData},
        datatTYpe: "json",
        success: function(response) {
            if (response.status == 'success') {
                if (subagent) {
                    if ($('#reservationRegister ul.validationMessage').length > 0) {
                        $('#reservationRegister ul.validationMessage').remove();
                    }

                    changeStep(3);
                } else {
                    showUserInfo(response);
                }
            } else {
                if (subagent) {
                    var errorList = $('#reservationRegister ul.validationMessage');

                    if (errorList.length > 0) {
                        errorList.html('');
                    } else {
                        $('#reservationRegister').append($('<ul class="validationMessage" />'));
                    }

                    $.each(response.data, function(field, error){
                        $('#reservationRegister ul.validationMessage').append('<li>'+error+'</li>');
                    });
                } else {
                    $('#reservationRegister').html(response.data.userRegisterPartial);
                }
            }

            $('#userInlineResLoader').hide();
        },
    });
}

function changeUserType(element) {
    if (element.val() == 'new') {
        $('#reservationLogin').hide();
        $('#reservationRegister').show();
    } else {
        $('#reservationLogin').show();
        $('#reservationRegister').hide();
    }
}

$(function(){
    $(document).on('click', '#loginButton, #userDataRefresh', function(){
        refreshLogin();
    });

    $(document).on('click', '#registerButton', function(){
        registerUser(false);
    });

    $('input[id*=_user_type]').change(function(){
        changeUserType($(this));
    });


    $('#reservationRegister').keypress(function(e){
        var val = $("input[type=submit][clicked=true]").val();
        if (e.which == 13 && $('.subagentPhone').length < 1) {
            e.preventDefault();
            registerUser(false);
        }
    });

    $(document).on('click', '.registerSubagentUser', function(e){
        e.preventDefault();
        registerUser(true);
    });

    $('#reservationLogin').keypress(function(e){
        if (e.which == 13) {
            e.preventDefault();
            refreshLogin();
        }
    });
});

function fillRegisteredUserData(r_user, id) {
    $(id + 'title').val(r_user.title);
    $(id + 'first_name').val(r_user.first_name);
    $(id + 'last_name').val(r_user.last_name);
    $(id + 'country').val(r_user.country);
    $(id + 'phone_type').val(r_user.phone_type);
    $(id + 'phone_number').val(r_user.phone_number);
    $(id + 'email').val(r_user.email);

    if (r_user.newsletter == 0) {
        $(id + 'newsletter').prop('checked', false);
    } else {
        $(id + 'newsletter').prop('checked', true);
    }
}

function refreshSignOnSignOff(response) {
    if ($('#reservationUserInfo').length < 1) {
        $('#reservationUser').prepend($('<div id="reservationUserInfo">'));
    }

    $('#userSignInSignOut').html(response.data.userSignInSignOut).show();
    $('#reservationRegister').fadeIn(fadeInAndOutTime);
    $('#reservationUserType, #reservationLogin').hide();
}

function removeRegistrationErrors() {
    $('#reservationRegister .validationMessage').remove();

    $('#reservationRegister input, #reservationRegister select')
        .parentsUntil('#reservationRegister')
        .removeClass('rowError');
}
